// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"129":"registration","239":"poll","400":"yes-no","683":"rising-star","996":"info"}[chunkId] + ".style." + {"129":"96c0b6f527dd47ed905d","239":"b752bd2a8f116db167ef","400":"5ba5c4d9276d4a83a3b8","683":"10c3204230cfff1a07d6","996":"87650d12920a24bb6896"}[chunkId] + ".css";
};